import {
  UserResource,
  UserResourceDocument,
} from "@repositories/userResource/types";
import axios from "axios";

export async function createUserResource(doc: UserResource) {
  const endpoint = `/api/v1/user/resources`;
  const response = await axios.post(endpoint, doc);

  const responseData = response.data;
  return responseData.data as UserResourceDocument;
}
